import { flagFactory } from '../icon';
import Svg from './cz.svg';

export default flagFactory(Svg);
